import { Users } from "lucide-react";

const SidebarSkeleton = () => {
  const skeletonContacts = Array(8).fill(null);

  return (
    <aside
      style={{
        height: "100%",
        width: "300px",
        borderRight: "1px solid #ddd",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fff",
      }}
    >
      <div
        style={{
          borderBottom: "1px solid #ddd",
          width: "100%",
          padding: "20px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Users size={24} />
          <span style={{ fontWeight: "600" }}>Contacts</span>
        </div>
      </div>

      <div style={{ overflowY: "auto", width: "100%", padding: "12px 0" }}>
        {skeletonContacts.map((_, idx) => (
          <div
            key={idx}
            style={{
              width: "100%",
              padding: "12px 20px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <div style={{ marginRight: "auto" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                  backgroundColor: "#e0e0e0",
                }}
              ></div>
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  height: "16px",
                  width: "128px",
                  backgroundColor: "#e0e0e0",
                  marginBottom: "8px",
                  borderRadius: "4px",
                }}
              ></div>
              <div
                style={{
                  height: "12px",
                  width: "64px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "4px",
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default SidebarSkeleton;
